import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const fmt = v => 'R$ ' + parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
const inpStyle = { width: '100%', padding: '9px 11px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };
const lbl = { color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' };
const card = { background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '20px 22px', marginBottom: '14px' };

const FORMAS = ['Dinheiro', 'PIX', 'Cartão Crédito', 'Cartão Débito', 'Financiamento', 'Troca', 'Boleto'];

export default function NovaVenda() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [veiculos, setVeiculos] = useState([]);
  const location = useLocation();
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buscaVeiculo, setBuscaVeiculo] = useState('');
  const [buscaCliente, setBuscaCliente] = useState('');

  // Formas de pagamento múltiplas
  const [formasSelecionadas, setFormasSelecionadas] = useState([{ forma: '', valor: '' }]);

  const [form, setForm] = useState({
    veiculo_id: '', cliente_id: '',
    valor_veiculo: '', valor_desconto: '0', valor_final: '',
    observacoes: '', transferencia_responsavel: 'cliente', valor_transferencia: '0',
    tem_garantia: true, data_garantia: '', km_garantia: '',
    tem_troca: false,
    veiculo_troca_marca: '', veiculo_troca_modelo: '', veiculo_troca_ano: '',
    veiculo_troca_cor: '', veiculo_troca_placa: '', veiculo_troca_renavam: '',
    veiculo_troca_chassi: '', veiculo_troca_combustivel: '',
    veiculo_troca_multas: false, veiculo_troca_ipva_pago: false,
  });

  const setV = (k, v) => setForm(f => ({ ...f, [k]: v }));

  useEffect(() => {
    api.get('/veiculos').then(r => { const lista = r.data.filter(v => v.status === 'estoque'); setVeiculos(lista); if (location.state?.veiculo_id) { setV('veiculo_id', String(location.state.veiculo_id)); setStep(2); } });
    api.get('/clientes').then(r => setClientes(r.data));
  }, []);

  const veiculoSelecionado = veiculos.find(v => String(v.id) === String(form.veiculo_id));
  const clienteSelecionado = clientes.find(c => String(c.id) === String(form.cliente_id));

  const veiculosFiltrados = veiculos.filter(v =>
    `${v.marca} ${v.modelo} ${v.placa || ''}`.toLowerCase().includes(buscaVeiculo.toLowerCase())
  );
  const clientesFiltrados = clientes.filter(c =>
    c.nome?.toLowerCase().includes(buscaCliente.toLowerCase()) ||
    c.cpf_cnpj?.includes(buscaCliente)
  );

  // Gerenciar formas de pagamento
  const addForma = () => setFormasSelecionadas(f => [...f, { forma: '', valor: '' }]);
  const removeForma = (i) => setFormasSelecionadas(f => f.filter((_, idx) => idx !== i));
  const setForma = (i, campo, val) => setFormasSelecionadas(f => f.map((item, idx) => idx === i ? { ...item, [campo]: val } : item));

  const formasPagamentoTexto = formasSelecionadas
    .filter(f => f.forma)
    .map(f => f.valor ? `${f.forma} (${fmt(f.valor)})` : f.forma)
    .join(' + ');

  useEffect(() => {
    if (veiculoSelecionado) {
      setV('valor_veiculo', veiculoSelecionado.valor_venda);
      setV('valor_final', veiculoSelecionado.valor_venda);
    }
  }, [form.veiculo_id]);

  useEffect(() => {
    const vv = parseFloat(form.valor_veiculo || 0);
    const desc = parseFloat(form.valor_desconto || 0);
    setV('valor_final', String(Math.max(0, vv - desc)));
  }, [form.valor_veiculo, form.valor_desconto]);

  const inp = (label, campo, tipo = 'text', opts) => (
    <div style={{ marginBottom: '12px' }}>
      <label style={lbl}>{label}</label>
      {opts ? (
        <select value={form[campo] || ''} onChange={e => setV(campo, e.target.value)} style={inpStyle}>
          <option value=''>Selecione</option>
          {opts.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
        </select>
      ) : (
        <input type={tipo} value={form[campo] || ''} onChange={e => setV(campo, e.target.value)} style={inpStyle} />
      )}
    </div>
  );

  const salvar = async () => {
    if (!form.veiculo_id || !form.cliente_id || !form.valor_final) { alert('Preencha todos os campos obrigatórios'); return; }
    if (formasSelecionadas.every(f => !f.forma)) { alert('Selecione pelo menos uma forma de pagamento'); return; }
    setLoading(true);
    try {
      await api.post('/vendas', {
        ...form,
        forma_pagamento: formasPagamentoTexto,
      });
      navigate('/vendas');
    } catch (err) { alert(err.response?.data?.error || 'Erro ao salvar venda'); }
    finally { setLoading(false); }
  };

  const steps = ['Veículo', 'Cliente', 'Valores', 'Pagamento', 'Confirmar'];

  return (
    <div style={{ maxWidth: '700px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533' }}>Nova Venda</div>
        <button onClick={() => navigate('/vendas')} style={{ background: 'none', border: 'none', color: '#6B7A8D', cursor: 'pointer', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>× Cancelar</button>
      </div>

      {/* Steps */}
      <div style={{ display: 'flex', gap: '6px', marginBottom: '20px' }}>
        {steps.map((s, i) => (
          <div key={s} style={{ flex: 1, textAlign: 'center', padding: '8px 4px', borderRadius: '7px', background: step === i + 1 ? '#1A3A5C' : step > i + 1 ? '#EAF5EE' : '#F4F6F9', cursor: step > i + 1 ? 'pointer' : 'default' }}
            onClick={() => step > i + 1 && setStep(i + 1)}>
            <div style={{ fontSize: '11px', fontWeight: '600', color: step === i + 1 ? '#fff' : step > i + 1 ? '#2D7D4F' : '#9AA3AE' }}>{i + 1}. {s}</div>
          </div>
        ))}
      </div>

      {/* Step 1 — Veículo */}
      {step === 1 && (
        <div style={card}>
          <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533', marginBottom: '14px' }}>Selecionar veículo</div>
          <input placeholder='Buscar por marca, modelo ou placa...' value={buscaVeiculo} onChange={e => setBuscaVeiculo(e.target.value)} style={{ ...inpStyle, marginBottom: '12px' }} />
          <div style={{ maxHeight: '320px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {veiculosFiltrados.map(v => (
              <div key={v.id} onClick={() => { setV('veiculo_id', String(v.id)); }}
                style={{ padding: '12px 14px', borderRadius: '8px', border: `1.5px solid ${String(v.id) === String(form.veiculo_id) ? '#1A3A5C' : 'rgba(26,58,92,0.12)'}`, background: String(v.id) === String(form.veiculo_id) ? '#E6F1FB' : '#fff', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: '600', fontSize: '14px', color: '#1C2533' }}>{v.marca} {v.modelo} {v.ano_mod}</div>
                  <div style={{ fontSize: '12px', color: '#9AA3AE', marginTop: '2px' }}>{v.placa || 'S/Placa'} · {v.cor}</div>
                </div>
                <div style={{ fontWeight: '700', fontFamily: "'DM Mono',monospace", color: '#2D7D4F', fontSize: '14px' }}>{fmt(v.valor_venda)}</div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '14px' }}>
            <button onClick={() => setStep(2)} disabled={!form.veiculo_id}
              style={{ padding: '9px 20px', background: form.veiculo_id ? '#1A3A5C' : '#F4F6F9', border: 'none', color: form.veiculo_id ? '#fff' : '#9AA3AE', borderRadius: '8px', cursor: form.veiculo_id ? 'pointer' : 'not-allowed', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
              Próximo →
            </button>
          </div>
        </div>
      )}

      {/* Step 2 — Cliente */}
      {step === 2 && (
        <div style={card}>
          <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533', marginBottom: '14px' }}>Selecionar cliente</div>
          <input placeholder='Buscar por nome ou CPF...' value={buscaCliente} onChange={e => setBuscaCliente(e.target.value)} style={{ ...inpStyle, marginBottom: '12px' }} />
          <div style={{ maxHeight: '320px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {clientesFiltrados.map(c => (
              <div key={c.id} onClick={() => setV('cliente_id', String(c.id))}
                style={{ padding: '12px 14px', borderRadius: '8px', border: `1.5px solid ${String(c.id) === String(form.cliente_id) ? '#1A3A5C' : 'rgba(26,58,92,0.12)'}`, background: String(c.id) === String(form.cliente_id) ? '#E6F1FB' : '#fff', cursor: 'pointer' }}>
                <div style={{ fontWeight: '600', fontSize: '14px', color: '#1C2533' }}>{c.nome}</div>
                <div style={{ fontSize: '12px', color: '#9AA3AE', marginTop: '2px' }}>{c.cpf_cnpj} · {c.telefone}</div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '14px' }}>
            <button onClick={() => setStep(1)} style={{ padding: '9px 18px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>← Voltar</button>
            <button onClick={() => setStep(3)} disabled={!form.cliente_id}
              style={{ padding: '9px 20px', background: form.cliente_id ? '#1A3A5C' : '#F4F6F9', border: 'none', color: form.cliente_id ? '#fff' : '#9AA3AE', borderRadius: '8px', cursor: form.cliente_id ? 'pointer' : 'not-allowed', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
              Próximo →
            </button>
          </div>
        </div>
      )}

      {/* Step 3 — Valores */}
      {step === 3 && (
        <div style={card}>
          <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533', marginBottom: '14px' }}>Valores</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
            {inp('Valor do veículo', 'valor_veiculo', 'number')}
            {inp('Desconto', 'valor_desconto', 'number')}
          </div>
          <div style={{ background: '#EAF5EE', borderRadius: '8px', padding: '14px', marginBottom: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '13px', fontWeight: '600', color: '#2D7D4F' }}>Valor final</span>
            <span style={{ fontSize: '22px', fontWeight: '900', fontFamily: "'DM Mono',monospace", color: '#2D7D4F' }}>{fmt(form.valor_final)}</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
            {inp('Transferência por', 'transferencia_responsavel', 'text', [{ v: 'cliente', l: 'Cliente' }, { v: 'loja', l: 'Loja' }])}
            {inp('Valor Transferência', 'valor_transferencia', 'number')}
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ color: '#6B7A8D', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input type='checkbox' checked={form.tem_garantia} onChange={e => setV('tem_garantia', e.target.checked)} />
              Incluir garantia
            </label>
          </div>
          {form.tem_garantia && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
              {inp('Data garantia', 'data_garantia', 'date')}
              {inp('KM garantia', 'km_garantia', 'number')}
            </div>
          )}
          <div style={{ marginBottom: '12px' }}>
            <label style={{ color: '#6B7A8D', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input type='checkbox' checked={form.tem_troca} onChange={e => setV('tem_troca', e.target.checked)} />
              Veículo de troca
            </label>
          </div>
          {form.tem_troca && (
            <div style={{ background: '#F4F6F9', borderRadius: '8px', padding: '14px', marginBottom: '12px' }}>
              <div style={{ fontSize: '12px', fontWeight: '600', color: '#6B7A8D', marginBottom: '10px', textTransform: 'uppercase' }}>Dados da troca</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
                {inp('Marca', 'veiculo_troca_marca')} {inp('Modelo', 'veiculo_troca_modelo')}
                {inp('Ano', 'veiculo_troca_ano')} {inp('Cor', 'veiculo_troca_cor')}
                {inp('Placa', 'veiculo_troca_placa')} {inp('Renavam', 'veiculo_troca_renavam')}
                {inp('Chassi', 'veiculo_troca_chassi')}
                {inp('Combustível', 'veiculo_troca_combustivel', 'text', [{ v: 'Gasolina', l: 'Gasolina' }, { v: 'Flex', l: 'Flex' }, { v: 'Etanol', l: 'Etanol' }, { v: 'Eletrico', l: 'Elétrico' }])}
              </div>
              <div style={{ display: 'flex', gap: '16px' }}>
                <label style={{ fontSize: '12px', color: '#6B7A8D', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                  <input type='checkbox' checked={form.veiculo_troca_multas} onChange={e => setV('veiculo_troca_multas', e.target.checked)} /> Com multas
                </label>
                <label style={{ fontSize: '12px', color: '#6B7A8D', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                  <input type='checkbox' checked={form.veiculo_troca_ipva_pago} onChange={e => setV('veiculo_troca_ipva_pago', e.target.checked)} /> IPVA pago
                </label>
              </div>
            </div>
          )}
          {inp('Observações', 'observacoes')}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
            <button onClick={() => setStep(2)} style={{ padding: '9px 18px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>← Voltar</button>
            <button onClick={() => setStep(4)} disabled={!form.valor_final}
              style={{ padding: '9px 20px', background: form.valor_final ? '#1A3A5C' : '#F4F6F9', border: 'none', color: form.valor_final ? '#fff' : '#9AA3AE', borderRadius: '8px', cursor: form.valor_final ? 'pointer' : 'not-allowed', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
              Próximo →
            </button>
          </div>
        </div>
      )}

      {/* Step 4 — Pagamento */}
      {step === 4 && (
        <div style={card}>
          <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533', marginBottom: '6px' }}>Formas de pagamento</div>
          <div style={{ fontSize: '12px', color: '#9AA3AE', marginBottom: '16px' }}>Você pode combinar mais de uma forma. O valor é opcional por forma.</div>

          {formasSelecionadas.map((item, i) => (
            <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', marginBottom: '10px' }}>
              <div style={{ flex: 2 }}>
                {i === 0 && <label style={lbl}>Forma</label>}
                <select value={item.forma} onChange={e => setForma(i, 'forma', e.target.value)} style={inpStyle}>
                  <option value=''>Selecione</option>
                  {FORMAS.map(f => <option key={f} value={f}>{f}</option>)}
                </select>
              </div>
              <div style={{ flex: 1 }}>
                {i === 0 && <label style={lbl}>Valor (opcional)</label>}
                <input type='number' placeholder='R$ 0,00' value={item.valor} onChange={e => setForma(i, 'valor', e.target.value)} style={inpStyle} />
              </div>
              {formasSelecionadas.length > 1 && (
                <button onClick={() => removeForma(i)}
                  style={{ padding: '8px 10px', background: '#FDECEA', border: 'none', color: '#C0392B', borderRadius: '7px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: '700', marginBottom: '1px' }}>
                  ×
                </button>
              )}
            </div>
          ))}

          <button onClick={addForma}
            style={{ padding: '8px 14px', background: 'transparent', border: '1px dashed rgba(26,58,92,0.3)', color: '#1A3A5C', borderRadius: '7px', cursor: 'pointer', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", marginBottom: '16px', width: '100%' }}>
            + Adicionar outra forma de pagamento
          </button>

          {formasPagamentoTexto && (
            <div style={{ background: '#E6F1FB', borderRadius: '8px', padding: '12px 14px', marginBottom: '14px' }}>
              <div style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600', marginBottom: '4px' }}>RESUMO DO PAGAMENTO</div>
              <div style={{ fontSize: '14px', fontWeight: '600', color: '#1A3A5C' }}>{formasPagamentoTexto}</div>
            </div>
          )}

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={() => setStep(3)} style={{ padding: '9px 18px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>← Voltar</button>
            <button onClick={() => setStep(5)} disabled={formasSelecionadas.every(f => !f.forma)}
              style={{ padding: '9px 20px', background: formasSelecionadas.some(f => f.forma) ? '#1A3A5C' : '#F4F6F9', border: 'none', color: formasSelecionadas.some(f => f.forma) ? '#fff' : '#9AA3AE', borderRadius: '8px', cursor: formasSelecionadas.some(f => f.forma) ? 'pointer' : 'not-allowed', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
              Próximo →
            </button>
          </div>
        </div>
      )}

      {/* Step 5 — Confirmar */}
      {step === 5 && (
        <div style={card}>
          <div style={{ fontSize: '14px', fontWeight: '700', color: '#1C2533', marginBottom: '16px' }}>Confirmar venda</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '16px' }}>
            {[
              { label: 'Veículo', val: veiculoSelecionado ? `${veiculoSelecionado.marca} ${veiculoSelecionado.modelo} ${veiculoSelecionado.ano_mod}` : '—' },
              { label: 'Cliente', val: clienteSelecionado?.nome || '—' },
              { label: 'Valor veículo', val: fmt(form.valor_veiculo) },
              { label: 'Desconto', val: fmt(form.valor_desconto) },
              { label: 'Transferência', val: `${form.transferencia_responsavel} · ${fmt(form.valor_transferencia)}` },
              { label: 'Garantia', val: form.tem_garantia ? 'Sim' : 'Não' },
            ].map(item => (
              <div key={item.label} style={{ background: '#F4F6F9', borderRadius: '8px', padding: '10px 12px' }}>
                <div style={{ fontSize: '10px', color: '#9AA3AE', fontWeight: '600', textTransform: 'uppercase', marginBottom: '3px' }}>{item.label}</div>
                <div style={{ fontSize: '13px', fontWeight: '500', color: '#1C2533' }}>{item.val}</div>
              </div>
            ))}
          </div>
          <div style={{ background: '#EAF5EE', borderRadius: '8px', padding: '14px', marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: '11px', color: '#2D7D4F', fontWeight: '600', marginBottom: '3px' }}>VALOR FINAL</div>
              <div style={{ fontSize: '22px', fontWeight: '700', color: '#2D7D4F', fontFamily: "'DM Mono',monospace" }}>{fmt(form.valor_final)}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '11px', color: '#6B7A8D', fontWeight: '600', marginBottom: '3px' }}>PAGAMENTO</div>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#1A3A5C' }}>{formasPagamentoTexto}</div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
            <button onClick={() => setStep(4)} style={{ padding: '9px 18px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>← Voltar</button>
            <button onClick={salvar} disabled={loading}
              style={{ padding: '10px 24px', background: '#2D7D4F', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
              {loading ? 'Salvando...' : '✓ Confirmar Venda'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
